// Editable-field schema per builtin Home/About section. Fields edit content[lang][sectionKey].
export const SECTION_LABELS = {
  hero: "Hero",
  home_services: "Servicii (Home)",
  home_works: "Lucrări selectate (Home)",
  home_courses: "Cursuri (Home)",
  home_journal: "Jurnal (Home)",
  koolt: "Koolt — Brațul de execuție",
  library: "Library (Knowledge Hub)",
  media: "Media / Video",
  principles: "Principii",
  contact: "Contact",
  footer: "Subsol",
  nav: "Navigație",
  about: "Despre",
  services: "Servicii",
};

export const BUTTON_SECTIONS = new Set(["hero", "home_services", "home_works", "home_courses", "home_journal", "koolt"]);

export const SECTION_IMAGES = {
  hero: [{ key: "hero_portrait", label: "Portret Hero" }],
};

export const SECTION_SCHEMA = {
  hero: [
    { k: "name.0", label: "Nume (rând 1)", type: "text" },
    { k: "name.1", label: "Nume (rând 2)", type: "text" },
    { k: "roles", label: "Roluri", type: "list", of: "string" },
    { k: "statement", label: "Declarație (serif)", type: "area" },
    { k: "intro", label: "Introducere", type: "area" },
  ],
  media: [
    { k: "label", label: "Etichetă", type: "text" },
    { k: "title", label: "Titlu", type: "text" },
    { k: "intro", label: "Intro", type: "area" },
    { k: "channelLabel", label: "Buton canal — text", type: "text" },
    { k: "channelUrl", label: "Buton canal — link", type: "text" },
  ],
  home_services: [
    { k: "label", label: "Etichetă", type: "text" },
    { k: "title", label: "Titlu", type: "text" },
    { k: "intro", label: "Intro", type: "area" },
  ],
  home_works: [
    { k: "label", label: "Etichetă", type: "text" },
    { k: "title", label: "Titlu", type: "text" },
    { k: "intro", label: "Intro", type: "area" },
  ],
  home_courses: [
    { k: "label", label: "Etichetă", type: "text" },
    { k: "title", label: "Titlu", type: "text" },
    { k: "intro", label: "Intro", type: "area" },
  ],
  home_journal: [
    { k: "label", label: "Etichetă", type: "text" },
    { k: "title", label: "Titlu", type: "text" },
    { k: "intro", label: "Intro", type: "area" },
  ],
  koolt: [
    { k: "label", label: "Text de poziționare (etichetă)", type: "text" },
    { k: "lead", label: "Subtitlu (serif)", type: "area" },
    { k: "title", label: "Titlul secțiunii", type: "text" },
    { k: "body", label: "Descriere", type: "area" },
  ],
  library: [
    { k: "label", label: "Etichetă pagină", type: "text" },
    { k: "title", label: "Titlu pagină", type: "text" },
    { k: "intro", label: "Intro pagină", type: "area" },
    { k: "perspectivesLabel", label: "Zonă 1 — Titlu (Perspectives)", type: "text" },
    { k: "perspectivesIntro", label: "Zonă 1 — Descriere", type: "area" },
    { k: "perspectivesBtn", label: "Zonă 1 — Text buton (ex: Vezi pe YouTube)", type: "text" },
    { k: "perspectivesBtnUrl", label: "Zonă 1 — Link buton (URL canal YouTube)", type: "text" },
    { k: "masterclassesLabel", label: "Zonă 2 — Titlu (Masterclasses)", type: "text" },
    { k: "masterclassesIntro", label: "Zonă 2 — Descriere", type: "area" },
    { k: "masterclassesBtn", label: "Zonă 2 — Text buton pe card (ex: Intră în curs)", type: "text" },
    { k: "masterclassesBtnUrl", label: "Zonă 2 — Link buton (gol = pagina cursului /library/slug)", type: "text" },
    { k: "dialoguesLabel", label: "Zonă 3 — Titlu (Dialogues)", type: "text" },
    { k: "dialoguesIntro", label: "Zonă 3 — Descriere", type: "area" },
    { k: "dialoguesBtn", label: "Zonă 3 — Text buton (ex: Ascultă podcastul)", type: "text" },
    { k: "dialoguesBtnUrl", label: "Zonă 3 — Link buton (URL playlist podcast)", type: "text" },
  ],
  principles: [
    { k: "label", label: "Etichetă", type: "text" },
    { k: "title", label: "Titlu", type: "text" },
    {
      k: "items",
      label: "Principii",
      type: "list",
      fields: [
        { k: "t", label: "Titlu", type: "text" },
        { k: "d", label: "Descriere", type: "area" },
      ],
    },
  ],
  contact: [
    { k: "label", label: "Etichetă", type: "text" },
    { k: "big", label: "Titlu mare (buton CTA)", type: "text" },
    { k: "dialogueLabel", label: "Text dialog (subsol)", type: "text" },
    { k: "email", label: "Email", type: "text" },
  ],
  footer: [
    { k: "tagline", label: "Tagline", type: "text" },
    { k: "city", label: "Oraș", type: "text" },
    { k: "rights", label: "Drepturi", type: "text" },
    { k: "admin", label: "Etichetă admin", type: "text" },
  ],
  nav: [
    { k: "home", label: "Acasă", type: "text" },
    { k: "library", label: "Library", type: "text" },
    { k: "journal", label: "Jurnal", type: "text" },
    { k: "portfolio", label: "Portofoliu", type: "text" },
    { k: "about", label: "Despre", type: "text" },
  ],
  about: [
    { k: "label", label: "Etichetă", type: "text" },
    { k: "title", label: "Titlu", type: "text" },
    { k: "lede", label: "Lede (serif)", type: "area" },
    { k: "bio", label: "Biografie (paragrafe)", type: "list", of: "string" },
    {
      k: "timeline",
      label: "Parcurs",
      type: "group",
      fields: [
        { k: "label", label: "Etichetă", type: "text" },
        {
          k: "entries",
          label: "Intrări",
          type: "list",
          fields: [
            { k: "years", label: "Ani", type: "text" },
            { k: "role", label: "Rol", type: "text" },
            { k: "org", label: "Organizație", type: "text" },
            { k: "desc", label: "Descriere", type: "area" },
          ],
        },
      ],
    },
    {
      k: "education",
      label: "Educație",
      type: "group",
      fields: [
        { k: "label", label: "Etichetă", type: "text" },
        {
          k: "items",
          label: "Intrări",
          type: "list",
          fields: [
            { k: "years", label: "Ani", type: "text" },
            { k: "title", label: "Titlu", type: "text" },
            { k: "org", label: "Organizație", type: "text" },
          ],
        },
      ],
    },
    {
      k: "appearances",
      label: "Apariții",
      type: "group",
      fields: [
        { k: "label", label: "Etichetă", type: "text" },
        {
          k: "items",
          label: "Intrări",
          type: "list",
          fields: [
            { k: "name", label: "Nume", type: "text" },
            { k: "place", label: "Loc", type: "text" },
          ],
        },
      ],
    },
  ],
  services: [
    { k: "label", label: "Etichetă", type: "text" },
    { k: "title", label: "Titlu", type: "text" },
    { k: "intro", label: "Intro", type: "area" },
    { k: "outro", label: "Text final", type: "area" },
    {
      k: "groups",
      label: "Arii de practică",
      type: "list",
      fields: [
        { k: "key", label: "Titlu", type: "text" },
        { k: "desc", label: "Descriere", type: "area" },
        { k: "items", label: "Capabilități", type: "list", of: "string" },
      ],
    },
  ],
};

export const CUSTOM_BLOCK_TYPES = [
  { type: "heading", label: "Titlu mare" },
  { type: "paragraph", label: "Paragraf" },
  { type: "quote", label: "Citat / declarație" },
  { type: "image", label: "Imagine" },
  { type: "fullwidth_image", label: "Imagine full-width" },
  { type: "image_text", label: "Imagine + text" },
  { type: "buttons", label: "Butoane" },
];
